import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { MobileGuard } from './guards/mobile.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./menu/menu.module').then((m) => m.MenuPageModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },

  {
    path: 'manualcapture',
    loadChildren: () =>
      import('./modals/manualcapture/manualcapture.module').then(
        (m) => m.ManualcapturePageModule
      ),
  },
  {
    path: 'auth-redirect',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/auth-redirect/auth-redirect.module').then(
        (m) => m.AuthRedirectPageModule
      ),
  },
  {
    path: 'notenant',
    loadChildren: () =>
      import('./pages/notenant/notenant.module').then(
        (m) => m.NotenantPageModule
      ),
  },
  {
    path: 'consult',
    loadChildren: () =>
      import('./pages/consult/consult.module').then((m) => m.ConsultPageModule),
  },
  {
    path: 'time-code',
    loadChildren: () =>
      import('./modals/time-code/time-code.module').then(
        (m) => m.TimeCodePageModule
      ),
  },
  {
    path: 'modifier',
    loadChildren: () =>
      import('./modals/modifier/modifier.module').then(
        (m) => m.ModifierPageModule
      ),
  },
  {
    path: 'hospital',
    loadChildren: () =>
      import('./modals/hospital/hospital.module').then(
        (m) => m.HospitalPageModule
      ),
  },
  {
    path: 'medical-aid-details',
    loadChildren: () =>
      import('./modals/medical-aid-details/medical-aid-details.module').then(
        (m) => m.MedicalAidDetailsPageModule
      ),
  },
  {
    path: 'custom-document-template',
    loadChildren: () =>
      import(
        './modals/custom-document-template/custom-document-template.module'
      ).then((m) => m.CustomDocumentTemplatePageModule),
  },
  {
    path: 'iod',
    loadChildren: () =>
      import('./modals/iod/iod.module').then((m) => m.IodPageModule),
  },
  {
    path: 'quickuploadform',
    loadChildren: () =>
      import('./modals/quickuploadform/quickuploadform.module').then(
        (m) => m.QuickuploadformPageModule
      ),
  },
  {
    path: 'add-era',
    loadChildren: () =>
      import('./modals/add-era/add-era.module').then((m) => m.AddEraPageModule),
  },
  {
    path: 'quick-input',
    loadChildren: () =>
      import('./modals/quick-input/quick-input.module').then(
        (m) => m.QuickInputPageModule
      ),
  },
  {
    path: 'createbillingtemplate',
    loadChildren: () =>
      import(
        './modals/createbillingtemplate/createbillingtemplate.module'
      ).then((m) => m.CreatebillingtemplatePageModule),
  },
  {
    path: 'managetemplatecodes',
    loadChildren: () =>
      import('./modals/managetemplatecodes/managetemplatecodes.module').then(
        (m) => m.ManagetemplatecodesPageModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthPageModule),
  },
  {
    path: 'benefits',
    loadChildren: () =>
      import('./modals/benefits/benefits.module').then(
        (m) => m.BenefitsPageModule
      ),
  },
  {
    path: 'navigator',
    loadChildren: () =>
      import('./pages/navigator/navigator.module').then(
        (m) => m.NavigatorPageModule
      ),
  },
  {
    path: 'claim-payments',
    loadChildren: () =>
      import('./modals/claim-payments/claim-payments.module').then(
        (m) => m.ClaimPaymentsPageModule
      ),
  },
  {
    path: 'search-tariffs',
    loadChildren: () =>
      import('./modals/search-tariffs/search-tariffs.module').then(
        (m) => m.SearchTariffsPageModule
      ),
  },
  {
    path: 'allocatepayment',
    loadChildren: () =>
      import('./modals/allocatepayment/allocatepayment.module').then(
        (m) => m.AllocatepaymentPageModule
      ),
  },
  {
    path: 'notallowed',
    loadChildren: () =>
      import('./pages/mobilenotallowed/mobilenotallowed.module').then(
        (m) => m.MobilenotallowedPageModule
      ),
  },
  {
    path: 'event-detail',
    loadChildren: () =>
      import('./modals/event-detail/event-detail.module').then(
        (m) => m.EventDetailPageModule
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./pages/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
